import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

@Component({
  selector: 'mop-close-button',
  template: `<button
    type="button"
    class="btn-close"
    aria-label="Close"
    [disabled]="disabled()"
    (click)="close.emit()"
  ></button>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'd-flex align-items-center justify-content-center',
  },
})
export class CloseButtonComponent {
  disabled = input(false, { transform: booleanAttribute });
  close = output();
}
